module.exports = __webpack_public_path__ + "static/simufact04-8869ace01f2113afdf0f920b535483e2.png";